import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh, useRecordContext, useShowController } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { ButtonNullable } from 'src/components/uiElements/CRUD/ButtonNullable'
import EventIcon from '@mui/icons-material/Event'
import PhoneIcon from '@mui/icons-material/Phone'
import { LoadingButton } from '@mui/lab'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TableContainer,
  Table,
  TableBody,
  Typography,
  TextField,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { DateProduct } from 'src/components/pages/sales/reservation/logic/common/DateProduct'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { blue } from 'src/assets/colors'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { CreateItemSupplierModal } from 'src/components/pages/sales/reservation/logic/modals/CreateItemSupplierModal'
import { ComplementaryItemModal } from 'src/components/pages/sales/reservation/logic/modals/ComplementaryItemModal'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { PricingModal } from 'src/components/pages/sales/reservation/logic/modals/PricingModal'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { Category, Comment, Visibility } from '@mui/icons-material'
import { deleteItemReservation } from '../../helper/deleteItemReservation'
import { guaranteeItemReservation } from '../../helper/guaranteeItemReservation'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from '../../helper/customAwait'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { EditOriginValues } from '../common/EditOriginValues'
import { OtherForm } from './OtherForm'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  PERMISSION_GET,
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'

import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'
import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { ExchangeType } from '../common/ExchangeType'
import {CommentsCardComponent} from '../common/CommentsCardComponent'
import { PostVentaStatus } from '../common/postventaStatus'
import { registerReturn } from '../../helper/registerReturn'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { AditionalInfoModal } from './AditionalInfoModal'
import { OptionalServicesModal } from './OptionalServicesModal'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { HotelsInfoModal } from './HotelsInfoModal'
import { ExtraFieldModal } from './ExtraFieldModal'
import { OtherCodeEditModal } from '../modals/OtherCodeEditModal.jsx'
import ReactJson from 'react-json-view'
import { timeZoneFormat } from '../../helper/argToTimezoneFormat'
import { ItemCancellation } from '../common/AutoCancelFields'
import { ChangePaymentStatusDialog } from '../common/ChangePaymentStatusDialog'
import { ChangeBillingStatusDialog } from '../common/ChangeBillingStatusDialog'

const ReserveInformation = ({reservation, refresh, isBillable, setIsBillable}) =>{
    const translate = useTranslate()
    const notify = useNotify()
    const [changeStatusDialog, setChangeStatusDialog] = useState(false)
    const [loadingBillable, setLoadingBillable] = useState(false)
    const other = useRecordContext()
    const [openCodeModal, setOpenCodeModal] = useState(false)
    const [openCodeExtra, setOpenCodeExtra] = useState(false)
    const [changePaymentStatusDialog, setChangePaymentStatusDialog] = useState(false)
    const [changeBillingStatusDialog, setChangeBillingStatusDialog] = useState(false)

    const {
        isFetching
      } = useShowController()

    const onChangeBillable = async () => {
      const newValue = isBillable != undefined ? !isBillable: !other?.is_billable
      setLoadingBillable(true)
      setIsBillable(newValue)

      try {
        await reservationServices.updateIsBillableProduct(other?.hash_, newValue)
        notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
      } catch (e) {
        setIsBillable(!newValue) // rollback visual
        notify('ra.notification.updated_error_masculine', {
          type: 'error',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
      } finally {
        setLoadingBillable(false)
      }
    }
    return(
      <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
        <CompleteSideCard>
          <Box display={'flex'}>
            <LeftSideCard>
              <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                  <ShowElement source='status' label={translate('ra.field.status')} />
                  <HasPermission resource={'item'} permission='edit_status'>
                    <EditIcon onClick={()=>setChangeStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                  </HasPermission>
              </div>
              <ShowElement
                source='created_at'
                label={translate('ra.field.created_at')}
                dateFormatCustom={timeZoneFormat}
              />
              <ShowElement
                source='source_relation.short_name'
                label={translate('ra.field.source')}
              />
            </LeftSideCard>
            <RigthSideCard>
              <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                <ShowElement
                  source={'payment_status'}
                  label={translate('ra.field.payment_status')}
                  status
                />
                <HasPermission resource={'item'} permission='edit_payment_status'>
                  <EditIcon onClick={()=>setChangePaymentStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                </HasPermission>
              </div>
              <PassengerOther reservation={reservation} />

              <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                <BillingStatusField />
                <HasPermission resource={'billing'} permission='edit_status'>
                  <EditIcon onClick={()=>setChangeBillingStatusDialog(true)} style={{cursor:'pointer', fontSize:'17px', color:'#6f7ce0', marginLeft:'12px'}}/>
                </HasPermission>
              </div>

              {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
                <Box style={{padding: '5px 0px 5px 0px'}}>
                  <Typography
                      variant='h7'
                      component='span'
                      style={{
                        padding: '0px 5px 0px 5px',
                        fontWeight: 600,
                        flex: 1,
                        maxWidth: 'fit-content',
                        display: 'inline-flex', 
                        alignItems: 'center',    
                        gap: '6px' 
                      }}
                    >
                    {translate('ra.field.is_billable')}
                    <Checkbox
                      checked={isBillable != undefined?isBillable:other?.is_billable}
                      onChange={onChangeBillable}
                      disabled={loadingBillable || isFetching}
                    />
                    {isFetching && (
                      <CircularProgress size={'10px'} sx={{ marginX: '5px' }} />
                    )}

                  </Typography>
                </Box>
              )}
              <BillingAutomaticField />
            </RigthSideCard>
          </Box>
          <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
            {translate('ra.title.provider_info')}
          </Typography>
          <Box display={'flex'}>
            <LeftSideCard>
              <ShowElement
                source='supplier_relation.name'
                label={translate('ra.field.provider')}
              />
              <ShowElement
                source={'pricing_relation.[0].currency_origin'}
                label={translate('ra.field.currency')}
              />
            </LeftSideCard>
            <RigthSideCard>
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', whiteSpace:'nowrap'}}>
                <ShowElement nullNoShow={true} source={'code'} label={translate('ra.field.provider_code')} />
                <EditIcon 
                  onClick={()=>hasPermissionFunction('other-detail', 'edit_codes') && setOpenCodeModal(true)} 
                  color={hasPermissionFunction('other-detail', 'edit_codes')?'primary':'disabled'}
                  style={{fontSize:'18px', cursor:hasPermissionFunction('other-detail', 'edit_codes') ? 'pointer':'default'}}
                />
                {other.extra && (
                  <HasPermission resource={'other-detail'} permission='revision'>
                    <Visibility style={{cursor:'pointer'}} color={'primary'} onClick={()=>setOpenCodeExtra(true)}/>
                  </HasPermission>
                )}
              </div>
              <ShowElement nullNoShow={true} source={'tour_id'} label={translate('ra.field.tour_id')} />
            </RigthSideCard>
          </Box>
        </CompleteSideCard>
        <ChangeStatusDialog
            open={changeStatusDialog}
            setOpen={setChangeStatusDialog}
            refresh={refresh}
          />
        <ChangePaymentStatusDialog
            open={changePaymentStatusDialog}
            setOpen={setChangePaymentStatusDialog}
            refresh={refresh}
          />
        <ChangeBillingStatusDialog
          open={changeBillingStatusDialog}
          setOpen={setChangeBillingStatusDialog}
          refresh={refresh}
        />

        <Dialog
            open={openCodeModal}
            onClose={()=>setOpenCodeModal(false)}
          >
          <DialogTitle>
            {translate('ra.title.code_edit')}
          </DialogTitle>
          <DialogContent>
            <OtherCodeEditModal refresh={refresh} setOpenCodeModal={setOpenCodeModal} />
          </DialogContent>
        </Dialog>
        <Dialog
          open={openCodeExtra}
          onClose={() => setOpenCodeExtra(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>{translate('ra.field.code')}</DialogTitle>
          <DialogContent>
            <ReactJson
              src={other.extra || {}}
              style={{ backgroundColor: 'white' }}
              name={null}
              iconStyle='triangle'
              collapsed={false}
              enableClipboard={false}
              displayDataTypes={false}
            />
          </DialogContent>
          <DialogActions>
            <Button
              color='error'
              variant='outlined'
              onClick={() => setOpenCodeExtra(false)}
            >
              {translate('ra.action.close')}
            </Button>
          </DialogActions>
        </Dialog>
      </ShowCard>
    )
  }

const ProductLineField = () =>{
  const translate = useTranslate()
  const other = useRecordContext()
  const productLine = other.extra?.provider?.product_line ?? null
  const data = productLine ? productLine.id + ' - ' + productLine.name :null
  return(
    data &&
    <ShowElement nullNoShow={true} data={data} label={translate('ra.field.product_line')} />
  )
}

const PassengerOther = ({ reservation }) => {
  const otherProduct = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = otherProduct?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ContextOther = ({ reservation }) => {
  const otherProduct = useRecordContext()
  const translate = useTranslate()
  const [openOptionalServices, setOpenOptionalServices] = useState(false)
  const [selectedOptional, setSelectedOptional] = useState(null)

  useEffect(()=>{
    if(selectedOptional){
      setOpenOptionalServices(true)
    }
  },[selectedOptional])

  if (otherProduct) {
    return (
      <>
        <DateProduct
          date_in={otherProduct?.date_in}
          date_out={otherProduct?.date_out}
          date_in_label={translate('ra.field.date_origin_service')}
          date_out_label={translate('ra.field.date_destination_service')}
        />
        {otherProduct?.optional?.length > 0 && 
        <div style={{display:'flex', flexDirection:'column', marginTop:'15px'}}>
          <label
            style={{fontWeight:'bold'}}
          >
            {translate('ra.field.optional_services')}
          </label>
          {otherProduct?.optional.map((opt, index)=>(
            <div key={opt.id || index} style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
              <label>
                {opt.optional || opt.code || 'Opcional'}
              </label>
              <HasPermission resource={'other-detail'} permission='optional'>
                <VisibilityIcon 
                  color='info'
                  style={{cursor:'pointer', marginLeft:'10px'}}
                  onClick={()=>setSelectedOptional(opt)}
                />
              </HasPermission>
            </div>
          ))}
        </div>
        }
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        <ItemCancellation autoCancelDate={otherProduct?.autocancel_date} cancellations={otherProduct?.cancel_info_relation}/>
        <Passenger
          itemId={otherProduct.item_id}
          passengers={otherProduct?.pax_relation}
          idResource={reservation?.id}
        />
        <OptionalServicesModal data={selectedOptional} open={openOptionalServices} handleClose={()=>{setOpenOptionalServices(false);setSelectedOptional(null)}}/>
      </>
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const ContextOtherForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const otherProduct = useRecordContext()
  if (otherProduct && openProductModal) {
    return (
      <OtherForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={otherProduct}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={otherProduct}
      />
    )
  }
}

const LiquidationCards = ({enableReliquidation}) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)
  
  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    
  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }

  const handleCLickRule = (ruleId) => {
    if (ruleId) {
      window.open(`/#/business-rule/${ruleId}`, '_blank')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_wholesaler?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_wholesaler' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              posTitle={
                <HasPermission resource={'business-rule'} permission='view'>
                  <Box sx={{ flex: 1, textAlign: 'end' }}>
                    <Button
                      variant='text'
                      onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied)}
                    >
                      {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_retail?.rule_applied_info?.rule_applied}
                    </Button>
                  </Box>
                </HasPermission>
              }
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing node_liquidation='liquidation_retail' />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            posTitle={
              <HasPermission resource={'business-rule'} permission='view'>
                <Box sx={{ flex: 1, textAlign: 'end' }}>
                  <Button
                    variant='text'
                    onClick={() => handleCLickRule(item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied)}
                  >
                    {translate('ra.field.rule_short')} {item?.pricing_relation?.[0]?.liquidation_supplier?.rule_applied_info?.rule_applied}
                  </Button>
                </Box>
              </HasPermission>
            }
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing node_liquidation='liquidation_supplier' />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
          title={decideLiquidation()}
          contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
          buttonConfirmText={translate('ra.message.yes')}
          buttonCancel={translate('ra.message.no')}
          setOpen={setOpenReliquidateModal}
          setConfirm={setConfirmReliquidate}
          open={openReliquidateModal}
          loadingModalButton={reliquidateLoading}
        />
    </>
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const otherProduct = useRecordContext()
  if (otherProduct) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={otherProduct} />
      </ShowCard>
    )
  }
}

export const OtherProduct = ({ reservation, otherProduct, editMode = false }) => {
  const translate = useTranslate()
  const refresh = useRefresh()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')
  const [confirm, setConfirm] = useState(false)
  // const [individualRecord, setIndividualRecord] = useState({})
  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)
  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false)
  const [confirmGuarantee, setConfirmGuarantee] = useState(false)
  const [loadingGuaranteeItem, setLoadingGuaranteeItem] = useState(false)
  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')
  const [openProductModal, setOpenProductModal] = useState(false)
  const { setCardLoading } = useCardLoading()

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)

  const [openAfterSalesItemModal, setOpenAfterSalesItemModal] = useState(false)
  const [openCreateItemSupplierModal, setOpenCreateItemSupplierModal] = useState(false)
  const [itemSupplierItemId, setItemSupplierItemId] = useState(null)
  const [openComplementaryModal, setOpenComplementaryModal] = useState(false)
  const [loadingComplementaryItem, setLoadingComplementaryItem] = useState(false)
  const [confirmAfterSalesItem, setConfirmAfterSalesItem] = useState(false)
  const [loadingAfterSalesReservationItem, setLoadingAfterSalesReservationItem] = useState(false)

  const [historyCostsDialog, setHistoryCostsDialog] = useState()

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [isBillable, setIsBillable] = useState()

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  const [openAditionalInfo, setOpenAditionalInfo] = useState(false)

  const [openHotelsInfo, setOpenHotelsInfo] = useState(false)

  const [openIncludedInfo, setOpenIncludedInfo] = useState(false)

  const [openNotIncludedInfo, setOpenNotIncludedInfo] = useState(false)

  const [openObservationsModal, setOpenObservationsModal] = useState(false)


  useEffect(() => {
    if (confirmGuarantee) {
      guaranteeItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingGuaranteeItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmGuarantee,
        setOpenGuaranteeModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmGuarantee])

  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
    if (confirmRegisterReturn) {
      registerReturn({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingRegisterReturnItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmRegisterReturn,
        setOpenRegisterReturnModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmRegisterReturn])

  useEffect(() => {
    if (confirmAfterSales) {
      afterSalesItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingAfterSalesItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmAfterSales,
        setOpenAfterSalesModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSales])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (changePostVentaStatus) {
      PostVentaStatus({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingPostventaStatus,
        setNameReserve,
        setHashItemReserve,
        setChangePostventaStatus,
        actualStatus
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePostVentaStatus])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingCancelItem,
        setNameReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if(error.response.data?.detail){
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setOpenMoveModal(false)
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
      }
    }
  }


  if (otherProduct) {
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingCancelItem || loadingDeleteItem}
        >
          <CircularProgress color='inherit' />
        </Backdrop>
        <TabProduct
          products={otherProduct}
          labelGetter={(product) => {
            if (!product?.id_detail) return 'ERROR'
            if (product.product?.short_name === 'CIRCUITOS TURISTICOS') {
              return product.name || product.destination || ''
            }
            if (product.destination && product.name) return `${product.destination} / ${product.name}`
            return product.name || product.destination || ''
          }}
          getStyle={(product) => (product?.id_detail ? null : { color: 'red' })}
        >
          {!editMode && (
            <ToolbarReservation
              resource='other-detail'
              loadingCancel={loadingCancelItem}
              onCancel={(otherProduct) => {
                setOpen(true)
                setHashItemReserve(otherProduct?.hash_)
                setNameReserve(otherProduct?.name)
              }}
              reservation={reservation}
              onDeleted={(otherProduct) => {
                setOpenDeleteModal(true)
                setHashItemReserve(otherProduct?.hash_)
                setNameReserve(otherProduct?.name)
              }}
              loadingDeleteItem={loadingDeleteItem}
              onGuaranteed={(otherProduct) => {
                setOpenGuaranteeModal(true)
                setHashItemReserve(otherProduct?.hash_)
                setNameReserve(otherProduct?.name)
              }}
              loadingGuaranteeItem={loadingGuaranteeItem}
              onClone={(otherProduct) => {
                setOpenCloneModal(true)
                setHashItemReserve(otherProduct?.hash_)
                setNameReserve(otherProduct?.name)
              }}
              loadingCloneItem={loadingCloneItem}
              onMove={(otherProduct) => {
                setOpenMoveModal(true)
                setHashItemReserve(otherProduct?.hash_)
                setNameReserve(otherProduct?.name)
              }}
              loadingMoveItem={loadingMoveItem}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(otherProduct)=>{
                setOpenAfterSalesModal(true)
                setHashItemReserve(otherProduct?.hash_)
                setNameReserve(otherProduct?.name)}
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (otherProduct)=>{
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(otherProduct?.hash_)
                  setNameReserve(otherProduct?.name)}
              }
              loadingRegisterReturn = {loadingRegisterReturnItem}
              setLoadingRegisterReturn = {setLoadingRegisterReturnItem}
              postventaStatusButton={(otherProduct)=>{
                setChangePostventaStatus(true)
                setHashItemReserve(otherProduct?.hash_)
                setActualStatus(otherProduct.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
              onAfterSalesItem={(otherProduct) => {
                setOpenAfterSalesItemModal(true)
                setHashItemReserve(otherProduct?.hash_)
              }
              }
              onComplementary={(otherProduct) => {
                setOpenComplementaryModal(true)
                setHashItemReserve(otherProduct?.hash_)
              }}
              loadingComplementaryItem={loadingComplementaryItem}
              onItemSupplierCreate={(otherProduct) => {
                setItemSupplierItemId(otherProduct?.item_id ?? otherProduct?.id)
                setOpenCreateItemSupplierModal(true)
              }}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <ContextOtherForm
                reservation={reservation}
                openProductModal={openProductModal}
                onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                setOpenProductModal={setOpenProductModal}
              />
              <Grid container spacing={1}>
                <Grid item xs={12} md={12} lg={12} xl={8}>
                  <ReserveInformation
                    reservation={reservation} 
                    refresh = {refresh} 
                    isBillable = {isBillable} 
                    setIsBillable = {setIsBillable}
                  />
                  <ConfirmationDialog
                    title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                    buttonConfirmText={translate('ra.message.yes')}
                    buttonCancel={translate('ra.message.no')}
                    setOpen={setOpen}
                    setConfirm={setConfirm}
                    open={open}
                  />

                  <ConfirmationDialog
                    title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                    buttonConfirmText={translate('ra.message.yes')}
                    buttonCancel={translate('ra.message.no')}
                    setOpen={setOpenCloneModal}
                    setConfirm={setConfirmClone}
                    open={openCloneModal}
                    loadingModalButton={loadingCloneItem}
                  />
                  <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                    <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.title.price_history')}
                        <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setHistoryCostsDialog(false)}}/>
                      </DialogTitle>
                    <DialogContent>
                        <HistoryCostsDialog/>
                    </DialogContent>
                  </Dialog>
                  <ConfirmationDialog
                    title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                    buttonConfirmText={translate('ra.message.yes')}
                    buttonCancel={translate('ra.message.no')}
                    setOpen={setOpenDeleteModal}
                    setConfirm={setConfirmDelete}
                    open={openDeleteModal}
                    loadingModalButton={loadingDeleteItem}
                  />

                  <ConfirmationDialog
                    title={translate('ra.message.after_sales', { reserva: nameReserve })}
                    buttonConfirmText={translate('ra.message.yes')}
                    buttonCancel={translate('ra.message.no')}
                    setOpen={setOpenAfterSalesModal}
                    setConfirm={setConfirmAfterSales}
                    open={openAfterSalesModal}
                    loadingModalButton={loadingAfterSalesItem}
                  />

                  <ConfirmationDialog
                    title={translate('ra.message.register_return', { reserva: nameReserve })}
                    buttonConfirmText={translate('ra.message.yes')}
                    buttonCancel={translate('ra.message.no')}
                    setOpen={setOpenRegisterReturnModal}
                    setConfirm={setConfirmRegisterReturn}
                    open={openRegisterReturnModal}
                    loadingModalButton={loadingRegisterReturnItem}
                  />

                  <ConfirmationDialog
                    title={translate('ra.message.guarantee_item_reserva', { item: nameReserve })}
                    buttonConfirmText={translate('ra.message.yes')}
                    buttonCancel={translate('ra.message.no')}
                    setOpen={setOpenGuaranteeModal}
                    setConfirm={setConfirmGuarantee}
                    open={openGuaranteeModal}
                    loadingModalButton={loadingGuaranteeItem}
                  />

                  <ConfirmationDialog
                    title={translate('ra.message.new_after_sales_item_confirmation')}
                    buttonConfirmText={translate('ra.message.yes')}
                    buttonCancel={translate('ra.message.no')}
                    setOpen={setOpenAfterSalesItemModal}
                    setConfirm={setConfirmAfterSalesItem}
                    open={openAfterSalesItemModal}
                    loadingModalButton={loadingAfterSalesReservationItem}
                  />
                  <CreateItemSupplierModal
                    open={openCreateItemSupplierModal}
                    itemId={itemSupplierItemId}
                    onClose={() => setOpenCreateItemSupplierModal(false)}
                  />
                    <ComplementaryItemModal
                      open={openComplementaryModal}
                      hashItem={hashItemReserve}
                      onClose={() => setOpenComplementaryModal(false)}
                    />

                  <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                    <DialogTitle>Mover item</DialogTitle>
                    <DialogContent>
                      <Grid container spacing={3}>
                        <EditInputsWrap
                          label={translate('ra.field.reservation_number')}
                          md={12}
                          lg={12}
                          style={{ minHeight: 0 }}
                        >
                          <TextField
                            value={reservationNumberMove}
                            onChange={(e) => setReservationNumberMove(e.target.value)}
                            size='small'
                            fullWidth
                          />
                        </EditInputsWrap>
                      </Grid>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        variant='outlined'
                        onClick={() => {
                          setNameReserve('')
                          setHashItemReserve('')
                          setReservationNumberMove('')
                          setOpenMoveModal(false)
                        }}
                      >
                        Cancelar
                      </Button>
                      <LoadingButton loading={loadingMoveItem} variant='contained' onClick={handleMoveItem}>
                        Aceptar
                      </LoadingButton>
                    </DialogActions>
                  </Dialog>
                </Grid>

                <Grid item xs={12} md={12} lg={12} xl={4}>
                  <WrapperCardId>
                    <ContactModal
                      open={openContactModal}
                      loadingButton={loadingContactModal}
                      handleClose={() => setOpenContactModal(false)}
                      onSubmit={(record, cardId) => {
                        handleUpdateContact(
                          record,
                          cardId,
                          setLoadingContactModal,
                          setOpenContactModal,
                          notify,
                          refresh,
                          setCardLoading
                        )
                      }}
                      titleModal={translate('ra.title.update_contact')}
                    />
                    <ShowCard
                      iconHeader={<PhoneIcon />}
                      title={translate('ra.title.contanct')}
                      actionButtonIcon={!editMode && <EditIcon />}
                      variant='text'
                      onClickButton={() => {
                        setOpenContactModal(true)
                      }}
                    >
                      <CompleteSideCard>
                        <ShowElement source='contact.name' label={translate('ra.field.name')} />
                        <ShowElement nullNoShow={true} source='contact.surname' label={translate('ra.field.surname')} />
                        <ShowElement nullNoShow={true} source='contact.email' label={translate('ra.field.email')} />
                        <ShowElement nullNoShow={true}
                          source='contact.phone_number'
                          label={translate('ra.field.phone_number')}
                        />
                      </CompleteSideCard>
                    </ShowCard>
                  </WrapperCardId>

                  <WrapperCardId>
                    <ObservationsCard />
                  </WrapperCardId>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <ShowCard iconHeader={<Category />} title={translate('ra.title.service_information')}>
                    <Box display={'flex'} flexDirection={'column'}>
                      <Box display={'flex'} flexDirection={'row'}>
                        <LeftSideCard style={{ display: 'block' }}>
                          <ShowElement nullNoShow={true} source='name' label={translate('ra.field.name')} />
                          {/* <ShowElement source='service_detail' label={translate('ra.field.detail_service')} /> */}
                          <ShowElement source='service_detail' label={translate('ra.field.detail_service')} />
                          <ShowElement
                            nullNoShow={true}
                            source={'hash'}
                            label={translate('ra.field.tour_id')}
                          />
                          <ShowElement nullNoShow={true} source='origin' label={translate('ra.field.start_city')} />
                          <ShowElement nullNoShow={true} source='destination' label={translate('ra.field.end_city')} />
                        </LeftSideCard>
                        <RigthSideCard style={{ display: 'block', marginLeft:'20px' }}>
                          <ShowElement nullNoShow={true} source={'provider'} label={translate('ra.field.operator')} />
                          <ProductLineField/>
                            <div style={{display:'flex', flexDirection:'column', alignItems:'flex-start'}}>
                              <div style={{display:'flex', flexDirection:'row'}}>

                                <ButtonNullable source={'extra'}
                                  style={{padding: '5px', fontWeight:'bold', textDecorationLine:'underline'}}
                                  onClick={()=>setOpenAditionalInfo(true)}
                                >{translate('ra.field.aditional_information')}
                                </ButtonNullable>

                                <ButtonNullable source={'observation'}
                                  style={{padding: '5px', fontWeight:'bold', textDecorationLine:'underline'}}
                                  onClick={()=>setOpenObservationsModal(true)}
                                >{translate('ra.field.observations')}
                                </ButtonNullable>

                              </div>
                              <div style={{display:'flex', flexDirection:'row'}}>

                                <ButtonNullable source={'included'}
                                  style={{padding: '5px', fontWeight:'bold', textDecorationLine:'underline'}}
                                  onClick={()=>setOpenIncludedInfo(true)}
                                >{translate('ra.field.included')}
                                </ButtonNullable>

                                <ButtonNullable source={'not_included'}
                                  style={{padding: '5px', fontWeight:'bold', textDecorationLine:'underline'}}
                                  onClick={()=>setOpenNotIncludedInfo(true)}
                                >{translate('ra.field.not_included')}
                                </ButtonNullable>

                              </div>
                            </div>

                          <ButtonNullable source={'hotels'}
                            style={{padding: '5px', fontWeight:'bold', textDecorationLine:'underline'}}
                            onClick={()=>setOpenHotelsInfo(true)}
                          >{translate('ra.field.provided_hotels')}
                          </ButtonNullable>
                          
                        </RigthSideCard>
                      </Box>
                      <CompleteSideCard style={{ display: 'block' }}>
                          <ContextOther reservation={reservation} />
                      </CompleteSideCard>
                    </Box>
                  </ShowCard>
                </Grid>
              </Grid>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission resource='file-upload' permission={PERMISSION_GET}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <FilesCard />
                    </Grid>
                  </Grid>
                </WrapperCardId>
              </HasPermission>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                      <Grid item xs={12}>
                          <CommentsCardComponent />
                      </Grid>
                    </Grid>
                </WrapperCardId>
            </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  <PricingModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    reservation={reservation}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                        <HasPermission permission='revision' resource={'pricing'}>
                            <Button
                            onClick={()=>{setHistoryCostsDialog(true)}}
                            sx={{ paddingX: '10px', marginX:'5px' }}
                            size='small'
                            variant='contained'
                            >
                            {translate('ra.title.price_history')}
                            </Button>
                        </HasPermission>
                      </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal}/>
                    </div>
                  )}
                  <LiquidationCards enableReliquidation={enableReliquidation} />
                  <AditionalInfoModal open={openAditionalInfo} handleClose={()=>setOpenAditionalInfo(false)}/>
                  <HotelsInfoModal open={openHotelsInfo} handleClose={()=>setOpenHotelsInfo(false)}/>
                  <ExtraFieldModal open={openIncludedInfo} handleClose={()=>setOpenIncludedInfo(false)} field={'included'}/>
                  <ExtraFieldModal open={openNotIncludedInfo} handleClose={()=>setOpenNotIncludedInfo(false)} field={'not_included'}/>
                  <ExtraFieldModal open={openObservationsModal} handleClose={()=>setOpenObservationsModal(false)} field={'observation'}/>
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
